<script setup lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { provide, onMounted } from 'vue';
import { isPlatform } from '@ionic/vue';
import { useSimpleSessionManager } from '@/composables/useSimpleSessionManager';
import { useStudentActivityHeartbeat } from '@/composables/useStudentActivityHeartbeat';
import FullscreenToggle from '@/components/FullscreenToggle.vue';

// Provide FMS type
provide('fms-type', import.meta.env.APP_FMS_TYPE);

// Detect iOS and provide to components
const isIOS = isPlatform('ios');
provide('isIOS', isIOS);

// Initialize session management
useSimpleSessionManager();
useStudentActivityHeartbeat();

onMounted(() => {
  // Apply iOS-specific styling
  if (isIOS) {
    document.documentElement.classList.add('ios-device');
  }
});
</script>

<template>
  <ion-app>
    <ion-router-outlet />
    <FullscreenToggle />
  </ion-app>
</template>

<style>
/* Establish safe area variables */
:root {
  --ion-safe-area-top: env(safe-area-inset-top);
  --ion-safe-area-bottom: env(safe-area-inset-bottom);
  --ion-safe-area-left: env(safe-area-inset-left);
  --ion-safe-area-right: env(safe-area-inset-right);
}

/* iOS-specific adjustments */
.ios-device ion-tab-bar {
  padding-bottom: var(--ion-safe-area-bottom);
  height: auto;
}

.ios-device ion-content {
  --padding-bottom: var(--ion-safe-area-bottom);
}

/* For your questions component */
.ios-device .questions-container {
  height: calc(100% - var(--ion-safe-area-bottom) - var(--navigation-area-height));
}

/* Fullscreen mode styles */
:fullscreen {
  background-color: #f9fcf2;
}

:-webkit-full-screen {
  background-color: #f9fcf2;
}

:-moz-full-screen {
  background-color: #f9fcf2;
}

:-ms-fullscreen {
  background-color: #f9fcf2;
}

/* Prevent browser UI from showing in fullscreen */
:fullscreen ion-app {
  height: 100vh;
  width: 100vw;
}

:-webkit-full-screen ion-app {
  height: 100vh;
  width: 100vw;
}

:-moz-full-screen ion-app {
  height: 100vh;
  width: 100vw;
}

:-ms-fullscreen ion-app {
  height: 100vh;
  width: 100vw;
}

/* Fullscreen toast styling */
.fullscreen-toast {
  --background: rgba(0, 0, 0, 0.8);
  --color: white;
  --border-radius: 8px;
  font-weight: 500;
}
</style>
